import React, {useState} from 'react';
import {CTimePicker} from '@coreui/react-pro';
import './style/style.scss';
import moment from 'moment';
import {ClockIcon} from '../../assets/images';

interface ICXTimePickerProps {
    timepicker?: boolean;
    disabled?: boolean;
    zIndex?: number;
    onChange: Function;
    placeholder: string;
    value: string;
    onChangeField?: Function;
    field?: string;
    state?: any;
    effectiveStart?: Date;
    effectiveEnd?: Date;
    initialDateTime?: string; // expect date format maybe like '2024-01-01 10:30:30' or new Date().toString()
}

const CXTimePicker = ({
                          disabled = false,
                          timepicker = false,
                          zIndex,
                          onChange,
                          placeholder,
                          value,
                          onChangeField,
                          field,
                          state,
                          initialDateTime,
                      }: ICXTimePickerProps) => {
    const [focus, setFocus] = useState(false);
    const defaultStartTime = moment().startOf('day').toDate(); // default start time is 00:00:00
    const defaultInitDateTimeStr = !!initialDateTime ? initialDateTime : defaultStartTime; // if initialDateTime is empty, use defaultStartTime 'YYYY-MM-DD 00:00:00' as default
    const initTimeVal = new Date(value && isDateString(value) ? convertDateFormat(value) : defaultInitDateTimeStr); // if value is empty, use defaultInitDateTimeStr as default, else convert value to date format "YYYY-MM-DD HH:mm:ss"
    const [timeValue, setTimeValue] = useState<Date>(initTimeVal || new Date()); // if initTimeVal is invalid date, use new Date() as default

    /*
      ----------------------------- Sample component ------------------------------
      const [displayDate, setDisplayDate] = useState([pass in UTC date]);
      <CXDatePicker placeholder={"STD"} value={displayDate} onChange={setDisplayDate} timepicker={true} />
      ----------------------------- Sample component ------------------------------
    */

  /*
    ----------------------------- Save for future debugging -----------------------------
    console.log(` 1. first enter ${value} `);
    console.log(` 2. CDatePicker date ${!!value ? `${moment.utc(new Date(value)).format("YYYY-MM-DDTHH:mm:ss")}Z` : `${moment.utc().format("YYYY-MM-DDTHH:mm:ss")}Z`} `);
    ----------------------------- Save for future debugging -----------------------------
  */

    function isDateString(valueIn) {
      const date = new Date(valueIn);
      return !isNaN(date.getTime());
    }

    // convert date format from "2024-05-22T10:00:00.054Z" to "2024-05-22 10:00:00"
    function convertDateFormat(dateStr) {
      const date = new Date(dateStr);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const hours = String(date.getUTCHours()).padStart(2, '0');
      const minutes = String(date.getUTCMinutes()).padStart(2, '0');
      const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } 

    const toggleFocus = () => {
        if (!disabled) {
            setFocus(!focus);
        }
    };

  const select = () => {
    // return utc time to onChange function
    // casper version
    // let confirmTime = timeValue;
    // confirmTime.setHours(confirmTime.getHours() + 8)
    // const utcTime = confirmTime.toISOString()
    const utcTimeStr = moment(timeValue).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
    if (onChangeField) {
      onChangeField(utcTimeStr, field, state, onChange);
    }
    setFocus(false);
  };

    return (
        <div className={"cx-datepicker"} style={{zIndex: !!zIndex ? zIndex : 1038}}>
            <div className={"cx-form-control"}>
                <CTimePicker
                    className={`cx-datepicker-body ${disabled ? "cx-disabled" : ""}`}
                    locale="en-GB"
                    indicator={false}
                    time={timeValue}
                    placeholder={placeholder}
                    onTimeChange={(timeString, localeTimeString, date) => !disabled && setTimeValue(date ? date : new Date())}
                    onConfirm={() => !disabled && select()}
                    disabled={disabled}/>
                <ClockIcon className={`cx-calender-icon dropdown-toggle ${disabled ? "cx-disabled" : ""}`} height={16} width={16}/>
                {(focus || !!value) &&
                    <div className={"focused-label cx-datepicker-labels"} onClick={toggleFocus}>{placeholder}</div>}
                {(focus || !!value) && !disabled &&
                    <div className={"selected-date cx-datepicker-labels"}>{moment.utc(value)?.format("HH:mm")}</div>}
                {(!focus && !value) &&
                    <div className={`not-focused-label cx-datepicker-labels`} onClick={toggleFocus}>{placeholder}</div>}
            </div>
        </div>
    );
};

export default CXTimePicker;
